import React, { Component } from 'react'
import { Select, Input } from 'antd'

export type SelectEditableOption = {
  label: string,
  value: string
}

export type SelectEditableProps = {
  name?: string[],
  options?: SelectEditableOption[],
  editable?: boolean,
  value?: string | undefined,
  disabled?: boolean,

  size?: 'large' | 'middle' | 'small',
  placeholder?: string,
  allowClear?: boolean,

  form?: any,

  onChange?: (value: string, option: SelectEditableOption) => void,
  onSelect?: (...args: any) => void,
  onDeselect?: (...args: any) => void
}

export default class SelectEditable extends Component<SelectEditableProps> {

  static defaultProps = {
    size: 'middle',
    allowClear: false
  }

  state = {
    value: this.props.value,
    custom: false
  }

  componentDidMount() {
    const { name, form } = this.props

    if (name && form) {
      const value = form.getFieldValue(name)
      this.setState({
        value
      })
    }
  }

  handleChange = (ev: any, option?: any) => {
    const { name, form, onChange } = this.props

    if (ev.persist) {
      ev.persist()
    }

    // Fix value
    let value = typeof ev === 'string' ? ev : ''

    // Updated state callback
    const updatedCallback = () => {
      if (this.state.custom && ev.target) {
        form.setFields([
          {
            name: name,
            value: ev.target.value
          }
        ])
      } else {
        form.setFields([
          {
            name: name,
            value: value
          }
        ])
      }

      value = this.props.form.getFieldValue(this.props.name)
      if (onChange) {
        onChange(value, option)
      }
    }

    // Set field as custom
    if (!this.state.custom && value === '__CUSTOM__') {
      this.setState({
        custom: true
      }, updatedCallback)
    } else {
      this.setState({
        value
      }, updatedCallback)
    }
  }

  private renderSelect = () => {
    const { name, size, allowClear, placeholder, editable, disabled, options, onSelect, onDeselect } = this.props
    const { value } = this.state

    return (
      <Select
        value={value}
        size={size}
        allowClear={allowClear}
        disabled={disabled || false}
        placeholder={placeholder}
        onChange={this.handleChange}
        onSelect={onSelect}
        onDeselect={onDeselect}
      >
        {
          options?.map((option, index) => (
            <Select.Option key={`select-option-${name || 'unamed'}-${index}`} value={option.value}>{option.label}</Select.Option>
          ))
        }

        {
          editable ? (
            <Select.Option key={`select-${name || 'unamed'}-option-custom`} value="__CUSTOM__">CUSTOM</Select.Option>
          ) : null
        }
      </Select>
    )
  }

  private renderInput = () => {
    const { placeholder, size } = this.props

    return (
      <Input
        placeholder={placeholder}
        size={size}
        onChange={this.handleChange}
      />
    )
  }

  render() {
    const { custom } = this.state

    return (
      <div
        style={{
          width: '100%'
        }}
      >
       { !custom ? this.renderSelect() : this.renderInput() }
      </div>
    )
  }
}
